<template>
  <list-view :thead="['Perubahan', 'Status', 'Tanggal Perubahaan']">
    <template v-slot:tbody>
      <tr v-if="logsync.length < 1">
        <td colspan="4" class="text-center text-secondary">Tidak ada data</td>
      </tr>
      <tr class="box-updated" v-for="(item, index) in logsync" :key="index">
        <td>
            <table class="table box-updated__table">
              <thead>
                <th></th>
                <th>data lama</th>
                <th>data baru</th>
              </thead>
              <tbody class="border-0" v-for="(field) in Object.keys(item.olddata)" :key="field">
                <!-- <tr>
                  <td class="border-0">
                    {{ field }}
                  </td>
                </tr> -->
                <tr class="border-0"
                  v-for="(subfield) in (String(typeof item.olddata?.[field]) == 'string' ? [item.olddata?.[field]] : Object.keys(item.olddata?.[field]))"
                  :key="subfield">
                  <!-- <td class="align-top">{{ String(typeof item.olddata?.[field]) == "string" ? field : subfield }}</td> -->
                  <!-- <td class="align-top">:</td> -->
                  <td>{{ field }}</td> 
                  <td class="align-top">
                    <div class="d-flex gap-2">
                      <argon-badge color="secondary">{{ String(typeof item.olddata?.[field]) == "string" ?
                        item.olddata?.[field] : item.olddata?.[field]?.[subfield] }}</argon-badge>
                    </div>
                  </td>
                  <td>
                      <argon-badge color="success">{{ String(typeof item.newdata?.[field]) == "string" ? item.newdata?.[field] :
                        item.newdata?.[field]?.[subfield] }}</argon-badge>
                  </td>
                </tr>
              </tbody>
            </table>
        </td>
        <td>
          <argon-badge v-if="item.status == 'process'" color="info">{{ item.status }}</argon-badge>
          <argon-badge v-else-if="item.status == 'sync'" color="success">{{ item.status }}</argon-badge>
          <argon-badge v-else color="info">{{ item.status }}</argon-badge>
        </td>
        <td>
          <!-- 10 april 2023 12:13 WIB -->
          <span class="text-sm">{{ `${this.convertToMoment(item.created_at ?? "&nbsp;", "DD MMMM YYYY HH:mm")} WIB` }}</span>
        </td>
      </tr>
    </template>
  </list-view>
</template>

<script>
import ListView from '@/components/ListView.vue'
import ArgonBadge from '../../../components/ArgonBadge.vue'
export default {
  name: "ListViewLogSync",
  props: {
    logsync: {
      type: Array,
      required: true,
    }
  },
  components: {
    ListView,
    ArgonBadge
  }
}
</script>


<style scoped>
.box-updated {
  border-bottom: 10px solid white;
}
.box-updated td {
  background-color: #f5faff;
}

.box-updated__table th {
  border: none;
  padding-left: 8px;
}
.box-updated .badge-secondary {
  color: #92a8b9;
}
</style>